import React, { useContext } from 'react';

import { Select } from 'antd';
import _ from 'lodash';

import { UserContext } from '@contexts/UserContext';

import useAccountingGroupDepartments from '@hooks/CachedLists/UseAccountingGroupDepartments';

const DepartmentSelectorAccountingModels = ({ onChange, mode, value, emptyValue, networkAgencyID, ...rest }) => {
    const { currentUser } = useContext(UserContext);
    const departmentsObject = useAccountingGroupDepartments(networkAgencyID);
    const renderOptions = () => {
        if (departmentsObject.isSingleAgency) {
            return (
                <>
                    {emptyValue && (
                        <Select.Option value={null} label="All Departments">
                            All Departments
                        </Select.Option>
                    )}
                    <Select.OptGroup key="departments" label="Departments">
                        {departmentsObject.departments.map(({ Name, ID }) => (
                            <Select.Option key={ID} value={ID} label={Name}>
                                {Name}
                            </Select.Option>
                        ))}
                    </Select.OptGroup>
                    <Select.OptGroup key="other-options" label="Other Options">
                        <Select.Option value={-1} label="At least one Department">
                            At least one Department
                        </Select.Option>
                        <Select.Option value={-2} label="No Departments">
                            No Departments
                        </Select.Option>
                    </Select.OptGroup>
                </>
            );
        } else {
            const departmentsGrouped = _.groupBy(departmentsObject.departments, 'networkAgencyName');
            const departmentsOptions = Object.entries(departmentsGrouped).map(([agency, depts]) => ({
                agency,
                depts: depts.map(({ ID, Name }) => ({
                    Name: Name,
                    ID: ID,
                })),
            }));
            return (
                <>
                    {emptyValue && (
                        <Select.Option value={null} label="All Departments">
                            All Departments
                        </Select.Option>
                    )}
                    <Select.Option value={-1} label="At least one Department">
                        At least one Department
                    </Select.Option>
                    {departmentsOptions.map(({ agency, depts }) => (
                        <Select.OptGroup key={agency} label={agency}>
                            {depts.map(({ Name, ID }) => (
                                <Select.Option key={ID} value={ID} label={`${agency} / ${Name}`}>
                                    {Name}
                                </Select.Option>
                            ))}
                        </Select.OptGroup>
                    ))}
                    <Select.OptGroup key="other-options" label="Other Options">
                        <Select.Option value={-1} label="At least one Department">
                            At least one Department
                        </Select.Option>
                        <Select.Option value={-2} label="No Departments">
                            No Departments
                        </Select.Option>
                    </Select.OptGroup>
                </>
            );
        }
    };

    return (
        <Select
            autoComplete="off"
            mode={mode}
            value={value ? value : emptyValue ? null : currentUser.ActiveContext.depId}
            label={rest.label ? rest.label : 'Department'}
            style={{ width: '100%', minWidth: '200px' }}
            placeholder="Select Departments"
            onChange={onChange}
            allowClear={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            optionLabelProp="label"
        >
            {renderOptions()}
        </Select>
    );
};

export default DepartmentSelectorAccountingModels;
